import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/for-students/components/StudentsInteractive.tsx");
